import * as ACTIONS from 'constants/actions';
import { API_URL, HTTP_HEADERS } from 'constants/apis';
import config from 'config';
import { UserManager } from 'paycor-oidc-client';

const { AUTHENTICATION } = API_URL;

export const redirectOnUnauthenticated = () => {
	const _return = encodeURIComponent(window.location.href);
	return (window.location.href = `${AUTHENTICATION}/Signin?ReturnUrl=${_return}`);
};

export const redirectToLogout = () => {
	return (window.location.href = `${AUTHENTICATION}/Logout`);
};

export const refreshSession = () => {
	return fetch(`${AUTHENTICATION}/`, HTTP_HEADERS().GET);
};

export const clearUser = (dispatch) => {
	let manager = new UserManager(config.securitySettings);
	manager.removeUser().then(() => {
		dispatch({
			type: ACTIONS.LOGGED_IN_USER_LOADED,
			payload: null
		});
	});
};

export const onAuthFailed = (e) => {
	console.error('Authentication Failed:', e);
	redirectOnUnauthenticated();
};

export const onAuthError = (e) => {
	console.error('Authentication Error occurred:', e);
	// redirectOnUnauthenticated();
};
